// MessageCategoryMore.jsx
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import BrowseTab from '../container/BrowseTab.js';
import CategoryGroupContainer from '../container/CategoryGroup.js';
import CategoryGroupComponent from '../component/CategoryGroup.jsx';
import withRouter from '../component/WithRouter.jsx';
import media from '../style/media.js';
import { headerHeight, footerNavigationHeight } from '../style/variables.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';

class MessageCategoryMore extends PureComponent {
  componentDidMount() {
    const { fetchFeeds, trendingCategoryFeed, fetchLimit } = this.props;
    fetchFeeds({
      type: trendingCategoryFeed,
      limit: fetchLimit,
      page: 1,
    });
  }
  render() {
    const { t, categoryGroups, trendingCategories } = this.props;
    return (
      <Container>
        <BrowseTab />
        <Body>
          <CategoryGroupComponent
            title={t('trending_category', {
              ns: TranslationNamespace.FEED,
            })}
            categoryItems={trendingCategories}
            isInOverview={true}
          />
          {categoryGroups.map(group => (
            <CategoryGroupContainer
              key={group}
              groupName={group}
              isInOverview={true}
            />
          ))}
        </Body>
      </Container>
    );
  }
}

MessageCategoryMore.propTypes = {
  fetchFeeds: PropTypes.func,
  t: PropTypes.func.isRequired,
  trendingCategoryFeed: PropTypes.string,
  fetchLimit: PropTypes.number,
  categoryGroups: PropTypes.array,
  trendingCategories: PropTypes.array,
};

MessageCategoryMore.defaultProps = {
  fetchFeeds: () => null,
  trendingCategoryFeed: '',
  fetchLimit: 15,
  categoryGroups: [],
  trendingCategories: [],
};

const Container = styled.div`
  position: relative;
  margin: calc(var(--space-to-pinned-notification) + ${headerHeight}px) auto 0;
  width: 960px;

  border-right: 1px solid var(--background-color-secondary-on-dark, #232323);
  border-left: 1px solid var(--background-color-secondary-on-dark, #232323);
  background-color: var(--background-color-primary-on-dark, #191919);

  ${media.tablet`
    width: 682px;
  `};
  ${media.mobile`
    width: 100%;
    border-right: unset;
    border-left: unset;
  `};
`;

const Body = styled.div`
  padding: 20px 16px 32px;
  ${media.mobile`
    padding-top: 32px;
    padding-bottom: calc(32px + ${footerNavigationHeight}px);
  `}
`;

export default withTranslation()(withRouter(MessageCategoryMore));
